// extracted by mini-css-extract-plugin
export default {"diff-file-header":"DiffFileHeader-module__diff-file-header--Z8VIs","collapsed":"DiffFileHeader-module__collapsed--bTqtX","file-name":"DiffFileHeader-module__file-name--ryaCb"};